module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Cutoff")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('Cutoff')
      }
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('cutoff-manager', {
    attrs: {
      "isCutoffActive": _vm.getSelectedEvent.hasCutOff,
      "selectedChannels": _vm.getSelectedEvent.cutOffChannelsMain,
      "selectedAgents": _vm.getSelectedEvent.cutOffChannelsAgents,
      "cutOffTime": _vm.getSelectedEvent.cutOffTime,
      "softCutOff": _vm.getSelectedEvent.softCutOff
    },
    on: {
      "update:isCutoffActive": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "hasCutOff", $event)
      },
      "update:is-cutoff-active": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "hasCutOff", $event)
      },
      "update:selectedChannels": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffChannelsMain", $event)
      },
      "update:selected-channels": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffChannelsMain", $event)
      },
      "update:selectedAgents": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffChannelsAgents", $event)
      },
      "update:selected-agents": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffChannelsAgents", $event)
      },
      "update:cutOffTime": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffTime", $event)
      },
      "update:cut-off-time": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "cutOffTime", $event)
      },
      "update:softCutOff": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "softCutOff", $event)
      },
      "update:soft-cut-off": function($event) {
        return _vm.$set(_vm.getSelectedEvent, "softCutOff", $event)
      },
      "change": function($event) {
        return _vm.cutoffChanged()
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-203283e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaCutoff.vue
// module id = 1387
// module chunks = 0